import React, {useEffect, useState} from "react";
import SideNav from "../../containers/Technician/SideNav";
import {Route, Switch} from 'react-router-dom'
import routes from "../../routes";
import MainContent from "../../containers/Technician/MainContent";
import cssClasses from "./layout.module.css"

function LayoutTechnician(props) {

    return(
        <>
            <div className={cssClasses.layout}>
                <SideNav/>
                <MainContent/>
            </div>
        </>
    );

}

export default LayoutTechnician;

